import { render, staticRenderFns } from "./AdminBusinessSubscription.vue?vue&type=template&id=00c4b4fe"
import script from "./AdminBusinessSubscription.vue?vue&type=script&lang=js"
export * from "./AdminBusinessSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports